import React, { ComponentType, PropsWithChildren } from 'react';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';

const THUMB_SIZE = {
  thumb: {
    w: '240',
    h: '240',
  },
};

type ProductImageProps = {
  src: string | null;
  alt: string;
  Container: ComponentType<PropsWithChildren>;
};

export const ProductImage = ({ Container, src, alt }: ProductImageProps) => {
  const { t } = useTranslation();
  const optimizedImage = useOptimizedImages(src, THUMB_SIZE);

  return (
    <Container>
      <ImagePlaceholder
        src={optimizedImage.thumb?.x || ''}
        alt={alt}
        title={alt}
        loading="lazy"
        fallbackAlt={t('ui.image.alt')}
      />
    </Container>
  );
};
